export enum DataPipelineRoutes {
    Home = 'home',
    Administration = 'administration',
    MetadataCatalogs = 'metadata-catalogs',
    MetadataCatalogsFields = '/metadata-catalogs/fields',
    ContentMetadataCatalogs = 'content-metadata-catalogs',
    ContentMetadataCatalogsFields = '/content-metadata-catalogs/fields'
}
